import React from 'react';
import PropTypes from 'prop-types';
import theme from '@fortress-technology-solutions/fortress-component-library/theme';
import styled from 'styled-components';
import { tc } from 'utils/theme';

const StyledLabelWrapper = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: ${tc('labelColor')};
  color: ${theme.typography.inputLabel.color};
`;

/**
 * Reusable label for form inputs and form groups
 * @param {string} text text of the label
 * @param {boolean} required boolean to show the required asterisk in the UI
 */
const Label = ({ required, ...props }) => (
  <StyledLabelWrapper {...props}>
    {props.children}
    {required && ' *'}
  </StyledLabelWrapper>
);

Label.propTypes = {
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
};

Label.defaultProps = {
  required: false,
};

export default Label;
